import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=6779326c"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=6779326c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports